var RecoveryCodesModule = /** @class */ (function () {
    function RecoveryCodesModule() {
    }
    return RecoveryCodesModule;
}());
export { RecoveryCodesModule };
